import React from 'react';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';

function Form() {
    const pathFrontEnd = '/psp-documenttypes/';
    const pathBackEnd = config.endpoints.backend + 'psp/documenttypes/';

    const form = {
        labelTitleEdit: 'Editar Tipo de Documento',
        labelTitleView: 'Visualizar Tipo de Documento',
        labelTitleAdd: 'Novo Tipo de Documento',
        pathView: pathFrontEnd + 'view',
        urlGoBack: pathFrontEnd + 'list',
        endpointGetById: pathBackEnd + 'getById',
        endpointSave: pathBackEnd + 'save',
        validateOnChange: true,
        fields: [
            {
                name: 'name',
                label: 'Nome do Tipo de Documento',
                type: 'text',
                columnSize: 6,
                validations: {
                    required: true
                }
            },
            {
                name: 'allowed_formats',
                label: 'Formatos Permitidos',
                type: 'multiselect',
                columnSize: 6,
                options: [
                    { label: 'PDF (.pdf)', value: '.pdf' },
                    { label: 'PNG (.png)', value: '.png' },
                    { label: 'JPEG (.jpg, .jpeg)', value: '.jpeg' },
                    { label: 'Word (.doc, .docx)', value: '.docx' },
                    { label: 'Excel (.xls, .xlsx)', value: '.xlsx' },
                    { label: 'ZIP (.zip)', value: '.zip' },
                    { label: 'TXT (.txt)', value: '.txt' }
                ],
                validations: {
                    required: true
                }
            }
        ]
    };

    return (
        <CustomFormContainer
            form={form}
            content={<CustomForm form={form} />}
        />
    );
}

export default Form;
